(() => {

  /**
   * 這裡填 product.json 裡 sections 的 KEY
   *
   * 例如：
   *
   * "sections": {
   *   "main": {...},
   *   "features": {...},
   *   "product_tabs": {...},
   *   "ingredients": {...}
   * }
   *
   * 就填：
   *
   * sections: ['main', 'features', 'product_tabs']
   */

  const groups = [

    {
      name: 'product-top',
      className: 'product-group product-group--top',

      sections: [
        'main',
        'quick_order_list_XTrabM',
        'section_product_tabs_U8mYg9',
      ]
    },
    {
      name: 'product-bottom',
      className: 'product-group product-group--bottom',
      sections: [
        'product-sidebar'
      ]
    }

  ];


  function findSection(key) {
    return document.querySelector(
      `[id^="shopify-section-"][id$="__${key}"]`
    );
  }


  function getOuterWrapper(firstSection) {

    let outerWrapper = document.querySelector(
      '[data-product-groups-wrapper]'
    );

    if (!outerWrapper) {

      outerWrapper = document.createElement('div');

      outerWrapper.className = 'product-groups-wrapper';

      outerWrapper.setAttribute(
        'data-product-groups-wrapper',
        ''
      );

      firstSection.parentNode.insertBefore(
        outerWrapper,
        firstSection
      );

    }

    return outerWrapper;
  }


  function buildGroups() {

    /*
     * 找出所有 group 裡第一個存在的 section
     * 用來決定 outer wrapper 插入位置
     */
    const allSections = groups
      .flatMap(group => group.sections)
      .map(findSection)
      .filter(Boolean);

    if (!allSections.length) return;


    /*
     * 建立最外層 wrapper
     */
    const outerWrapper = getOuterWrapper(
      allSections[0]
    );


    groups.forEach(config => {

      const sections = config.sections
        .map(findSection)
        .filter(Boolean);

      if (!sections.length) return;


      let groupWrapper = document.querySelector(
        `[data-section-group="${config.name}"]`
      );


      /*
       * 建立 group wrapper
       */
      if (!groupWrapper) {

        groupWrapper = document.createElement('div');

        groupWrapper.className = config.className;

        groupWrapper.dataset.sectionGroup =
          config.name;

      }


      /*
       * 先把 group 放入最外層
       */
      outerWrapper.appendChild(groupWrapper);


      /*
       * 再把 Sections 搬入 group
       */
      sections.forEach(section => {

        groupWrapper.appendChild(section);

      });

    });

  }


  function init() {
    buildGroups();
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /*
   * Shopify Theme Editor
   */
  document.addEventListener(
    'shopify:section:load',
    init
  );

  document.addEventListener(
    'shopify:section:reorder',
    init
  );

})();